// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\nform[data-v-71f1c82b] {\n  margin-bottom: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
